import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, resolveDynamicComponent as _resolveDynamicComponent, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "flex items-center justify-between" }
const _hoisted_2 = {
  key: 0,
  class: "text-sm text-muted-foreground font-normal"
}
const _hoisted_3 = { class: "flex items-center gap-1" }
const _hoisted_4 = { class: "px-4 pt-2" }
const _hoisted_5 = {
  key: 0,
  class: "ml-1.5 inline-flex items-center justify-center h-5 min-w-5 px-1 rounded-full bg-primary text-primary-foreground text-xs"
}
const _hoisted_6 = {
  key: 0,
  class: "p-6 text-center text-muted-foreground"
}
const _hoisted_7 = {
  key: 1,
  class: "divide-y"
}
const _hoisted_8 = ["onClick"]
const _hoisted_9 = { class: "flex gap-3" }
const _hoisted_10 = { class: "shrink-0 mt-0.5" }
const _hoisted_11 = { class: "flex-1 min-w-0" }
const _hoisted_12 = { class: "flex items-start justify-between gap-2" }
const _hoisted_13 = { class: "flex items-center gap-1 shrink-0" }
const _hoisted_14 = {
  key: 0,
  class: "h-2 w-2 rounded-full bg-primary"
}
const _hoisted_15 = ["onClick"]
const _hoisted_16 = { class: "text-sm text-muted-foreground line-clamp-2 mt-0.5" }
const _hoisted_17 = {
  key: 0,
  class: "mt-2 space-y-2"
}
const _hoisted_18 = { class: "flex items-center gap-2" }
const _hoisted_19 = { class: "text-xs text-muted-foreground mt-1" }
const _hoisted_20 = {
  key: 0,
  class: "p-6 text-center text-muted-foreground"
}
const _hoisted_21 = {
  key: 1,
  class: "divide-y"
}
const _hoisted_22 = ["onClick"]
const _hoisted_23 = { class: "flex gap-3" }
const _hoisted_24 = { class: "shrink-0 mt-0.5" }
const _hoisted_25 = { class: "h-8 w-8 rounded-full flex items-center justify-center bg-primary/10" }
const _hoisted_26 = { class: "flex-1 min-w-0" }
const _hoisted_27 = { class: "flex items-start justify-between gap-2" }
const _hoisted_28 = { class: "text-sm font-medium" }
const _hoisted_29 = { class: "flex items-center gap-1 shrink-0" }
const _hoisted_30 = ["onClick"]
const _hoisted_31 = { class: "text-sm text-muted-foreground line-clamp-2 mt-0.5" }
const _hoisted_32 = {
  key: 0,
  class: "mt-2 space-y-2"
}
const _hoisted_33 = { class: "flex items-center gap-2" }
const _hoisted_34 = { class: "text-xs text-muted-foreground mt-1" }
const _hoisted_35 = {
  key: 0,
  class: "p-6 text-center text-muted-foreground"
}
const _hoisted_36 = {
  key: 1,
  class: "py-1"
}
const _hoisted_37 = { class: "flex items-center gap-2" }
const _hoisted_38 = { class: "text-sm font-medium" }
const _hoisted_39 = {
  key: 0,
  class: "inline-flex items-center justify-center h-5 min-w-5 px-1 rounded-full bg-primary text-primary-foreground text-xs"
}
const _hoisted_40 = { class: "text-xs text-muted-foreground" }
const _hoisted_41 = { class: "divide-y" }
const _hoisted_42 = ["onClick"]
const _hoisted_43 = { class: "flex gap-3 pl-6" }
const _hoisted_44 = { class: "flex-1 min-w-0" }
const _hoisted_45 = { class: "flex items-start justify-between gap-2" }
const _hoisted_46 = { class: "flex items-center gap-1 shrink-0" }
const _hoisted_47 = {
  key: 0,
  class: "h-2 w-2 rounded-full bg-primary"
}
const _hoisted_48 = ["onClick"]
const _hoisted_49 = { class: "text-sm text-muted-foreground line-clamp-1 mt-0.5" }
const _hoisted_50 = {
  key: 0,
  class: "mt-2 space-y-2"
}
const _hoisted_51 = { class: "flex items-center gap-2" }
const _hoisted_52 = { class: "text-xs text-muted-foreground mt-0.5" }
const _hoisted_53 = { class: "p-4" }

import { ref, computed } from 'vue'
import { useRouter } from 'vue-router'
import { useI18n } from 'vue-i18n'
import { useNotificationsStore } from '@/stores/notifications'
import { usePipelineApprovalApi } from '@/composables/usePipelineApprovalApi'
import { toast } from 'vue-sonner'
import { formatDistanceToNow } from 'date-fns'
import { es, enUS } from 'date-fns/locale'
import type { Notification, NotificationEntityType } from '@/types'
import type { NotificationGroupData } from '@/stores/notifications/getters'

import {
  Sheet,
  SheetContent,
  SheetHeader,
  SheetTitle,
} from '@/components/ui/sheet'
import { Button } from '@/components/ui/button'
import { Badge } from '@/components/ui/badge'
import { Textarea } from '@/components/ui/textarea'
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
  DialogFooter,
} from '@/components/ui/dialog'
import { ScrollArea } from '@/components/ui/scroll-area'
import { Separator } from '@/components/ui/separator'
import {
  Tabs,
  TabsContent,
  TabsList,
  TabsTrigger,
} from '@/components/ui/tabs'
import {
  Collapsible,
  CollapsibleContent,
  CollapsibleTrigger,
} from '@/components/ui/collapsible'
import {
  Bell,
  CheckCheck,
  FolderKanban,
  Layers,
  FileText,
  Ticket,
  FileCheck,
  ShoppingCart,
  MessageSquare,
  Calendar,
  Package,
  Trash2,
  Video,
  IterationCcw,
  X,
  ChevronDown,
  Users,
  UserPlus,
} from 'lucide-vue-next'


export default /*@__PURE__*/_defineComponent({
  __name: 'NotificationsDrawer',
  props: {
    open: { type: Boolean }
  },
  emits: ["update:open"],
  setup(__props: any, { emit: __emit }) {

const props = __props

const emit = __emit

const { t, locale } = useI18n()
const router = useRouter()
const notificationsStore = useNotificationsStore()
const { approvePipeline } = usePipelineApprovalApi()

const activeTab = ref('all')

// --- Aprobación de pipeline (notificaciones accionables) ---
// La notificación trae data: { action: 'approve_pipeline', pipelineId, phase }.
const isApprovalNotification = (n: Notification): boolean =>
  n.data?.action === 'approve_pipeline' && typeof n.data?.pipelineId === 'string'

// id de la notificación cuya acción está en vuelo (deshabilita sus botones)
const submittingId = ref<string | null>(null)

// Estado del diálogo de rechazo
const rejectDialogOpen = ref(false)
const rejectReason = ref('')
const rejectTarget = ref<Notification | null>(null)

const handleApprove = async (e: Event, notification: Notification) => {
  e.stopPropagation()
  const pipelineId = notification.data?.pipelineId
  if (typeof pipelineId !== 'string' || submittingId.value) return
  submittingId.value = notification.id
  try {
    const { message } = await approvePipeline(pipelineId, true)
    if (!notification.isRead) await notificationsStore.markAsRead(notification.id)
    toast('Pipeline aprobado', { description: message || undefined })
  } catch (err) {
    toast('No se pudo aprobar', {
      description: err instanceof Error ? err.message : 'Error inesperado',
    })
  } finally {
    submittingId.value = null
  }
}

const openRejectDialog = (e: Event, notification: Notification) => {
  e.stopPropagation()
  rejectTarget.value = notification
  rejectReason.value = ''
  rejectDialogOpen.value = true
}

const confirmReject = async () => {
  const notification = rejectTarget.value
  const pipelineId = notification?.data?.pipelineId
  const reason = rejectReason.value.trim()
  if (!notification || typeof pipelineId !== 'string' || !reason) return
  submittingId.value = notification.id
  try {
    const { message } = await approvePipeline(pipelineId, false, reason)
    if (!notification.isRead) await notificationsStore.markAsRead(notification.id)
    toast('Pipeline rechazado', { description: message || undefined })
    rejectDialogOpen.value = false
    rejectTarget.value = null
    rejectReason.value = ''
  } catch (err) {
    toast('No se pudo rechazar', {
      description: err instanceof Error ? err.message : 'Error inesperado',
    })
  } finally {
    submittingId.value = null
  }
}

const dateLocale = computed(() => locale.value === 'es' ? es : enUS)

const allNotifications = computed(() => notificationsStore.notifications)
const unreadNotifications = computed(() => notificationsStore.unreadNotifications)
const groupedNotifications = computed(() => notificationsStore.groupedNotifications)
const collapsedGroups = ref<Set<string>>(new Set())

const formatDate = (date: Date) => {
  return formatDistanceToNow(date, { addSuffix: true, locale: dateLocale.value })
}

const getNotificationIcon = (type: string) => {
  if (type.includes('project')) return FolderKanban
  if (type.includes('epic')) return Layers
  if (type.includes('requirement')) return FileText
  if (type.includes('ticket')) return Ticket
  if (type.includes('quotation')) return FileCheck
  if (type.includes('sales_order')) return ShoppingCart
  if (type.includes('petition')) return MessageSquare
  if (type.includes('appointment')) return Calendar
  if (type.includes('release')) return Package
  if (type.includes('comment')) return MessageSquare
  if (type.includes('meeting')) return Video
  if (type.includes('sprint')) return IterationCcw
  if (type.includes('prospect')) return Users
  if (type.includes('lead')) return UserPlus
  return Bell
}

const getGroupIcon = (group: string) => {
  const icons: Record<string, typeof Bell> = {
    projects: FolderKanban,
    backlog: FileText,
    meetings: Video,
    support: Ticket,
    commercial: ShoppingCart,
    releases: Package,
    crm: Users,
  }
  return icons[group] || Bell
}

const toggleGroup = (group: string) => {
  if (collapsedGroups.value.has(group)) {
    collapsedGroups.value.delete(group)
  } else {
    collapsedGroups.value.add(group)
  }
}

const getEntityRoute = (entityType?: NotificationEntityType, entityId?: string): string | null => {
  if (!entityType || !entityId) return null

  const routes: Record<NotificationEntityType, string> = {
    project: `/projects/${entityId}`,
    epic: `/epics/${entityId}`,
    requirement: `/requirements/${entityId}`,
    ticket: `/tickets/${entityId}`,
    quotation: `/quotations/${entityId}`,
    salesOrder: `/sales-orders/${entityId}`,
    petition: `/petitions/${entityId}`,
    appointment: `/calendar`,
    release: `/releases/${entityId}`,
    application: `/projects/${entityId}`,
    meeting: `/projects/${entityId}`,
    sprint: `/backlog`,
    prospect: `/crm`,
    lead: `/leads/${entityId}`,
    deliverable: `/deliverables/${entityId}`,
  }

  return routes[entityType] || null
}

const handleNotificationClick = async (notification: Notification) => {
  // Las notificaciones accionables (aprobar pipeline) se resuelven con sus botones,
  // no navegando al tocar la fila.
  if (isApprovalNotification(notification)) return

  if (!notification.isRead) {
    await notificationsStore.markAsRead(notification.id)
  }

  const route = getEntityRoute(notification.entityType, notification.entityId)
  if (route) {
    emit('update:open', false)
    router.push(route)
  }
}

const handleDelete = async (e: Event, notificationId: string) => {
  e.stopPropagation()
  await notificationsStore.deleteNotification(notificationId)
}

const handleMarkAllAsRead = async () => {
  await notificationsStore.markAllAsRead()
}

const handleDeleteAllRead = async () => {
  await notificationsStore.deleteAllRead()
}

const goToNotifications = () => {
  emit('update:open', false)
  router.push('/notifications')
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(Sheet), {
    open: props.open,
    "onUpdate:open": _cache[4] || (_cache[4] = ($event: any) => (emit('update:open', $event)))
  }, {
    default: _withCtx(() => [
      _createVNode(_unref(SheetContent), {
        side: "right",
        class: "w-full sm:max-w-xl lg:max-w-2xl p-0 flex flex-col"
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(SheetHeader), { class: "px-6 py-4 border-b" }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_1, [
                _createVNode(_unref(SheetTitle), { class: "flex items-center gap-2" }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(Bell), { class: "h-5 w-5" }),
                    _cache[5] || (_cache[5] = _createTextVNode(" Notificaciones ", -1)),
                    (_unref(notificationsStore).unreadCount > 0)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_2, " (" + _toDisplayString(_unref(notificationsStore).unreadCount) + " sin leer) ", 1))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }),
                _createElementVNode("div", _hoisted_3, [
                  (_unref(notificationsStore).unreadCount > 0)
                    ? (_openBlock(), _createBlock(_unref(Button), {
                        key: 0,
                        variant: "ghost",
                        size: "sm",
                        class: "h-8",
                        onClick: handleMarkAllAsRead
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_unref(CheckCheck), { class: "h-4 w-4 mr-1" }),
                          _cache[6] || (_cache[6] = _createTextVNode(" Marcar todas ", -1))
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  (_unref(notificationsStore).readNotifications.length > 0)
                    ? (_openBlock(), _createBlock(_unref(Button), {
                        key: 1,
                        variant: "ghost",
                        size: "sm",
                        class: "h-8 text-muted-foreground",
                        onClick: handleDeleteAllRead
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_unref(Trash2), { class: "h-4 w-4" })
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
                ])
              ])
            ]),
            _: 1
          }),
          _createVNode(_unref(Tabs), {
            modelValue: activeTab.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((activeTab).value = $event)),
            class: "flex-1 flex flex-col min-h-0"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_4, [
                _createVNode(_unref(TabsList), { class: "w-full" }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(TabsTrigger), {
                      value: "all",
                      class: "flex-1"
                    }, {
                      default: _withCtx(() => [...(_cache[7] || (_cache[7] = [
                        _createTextVNode(" Todas ", -1)
                      ]))]),
                      _: 1
                    }),
                    _createVNode(_unref(TabsTrigger), {
                      value: "unread",
                      class: "flex-1"
                    }, {
                      default: _withCtx(() => [
                        _cache[8] || (_cache[8] = _createTextVNode(" Sin leer ", -1)),
                        (_unref(notificationsStore).unreadCount > 0)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(_unref(notificationsStore).unreadCount), 1))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    }),
                    _createVNode(_unref(TabsTrigger), {
                      value: "grouped",
                      class: "flex-1"
                    }, {
                      default: _withCtx(() => [...(_cache[9] || (_cache[9] = [
                        _createTextVNode(" Agrupadas ", -1)
                      ]))]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _createVNode(_unref(TabsContent), {
                value: "all",
                class: "flex-1 mt-0 min-h-0"
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(ScrollArea), { class: "h-full" }, {
                    default: _withCtx(() => [
                      (allNotifications.value.length === 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                            _createVNode(_unref(Bell), { class: "h-12 w-12 mx-auto mb-3 opacity-50" }),
                            _cache[10] || (_cache[10] = _createElementVNode("p", null, "No hay notificaciones", -1))
                          ]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_7, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(allNotifications.value, (notification) => {
                              return (_openBlock(), _createElementBlock("div", {
                                key: notification.id,
                                class: _normalizeClass(["p-4 hover:bg-accent/50 cursor-pointer transition-colors group", { 'bg-accent/30': !notification.isRead }]),
                                onClick: ($event: any) => (handleNotificationClick(notification))
                              }, [
                                _createElementVNode("div", _hoisted_9, [
                                  _createElementVNode("div", _hoisted_10, [
                                    _createElementVNode("div", {
                                      class: _normalizeClass(["h-8 w-8 rounded-full flex items-center justify-center", notification.isRead ? 'bg-muted' : 'bg-primary/10'])
                                    }, [
                                      (_openBlock(), _createBlock(_resolveDynamicComponent(getNotificationIcon(notification.type)), {
                                        class: _normalizeClass(["h-4 w-4", notification.isRead ? 'text-muted-foreground' : 'text-primary'])
                                      }, null, 8, ["class"]))
                                    ], 2)
                                  ]),
                                  _createElementVNode("div", _hoisted_11, [
                                    _createElementVNode("div", _hoisted_12, [
                                      _createElementVNode("p", {
                                        class: _normalizeClass(["text-sm", notification.isRead ? 'text-muted-foreground' : 'font-medium'])
                                      }, _toDisplayString(notification.title), 3),
                                      _createElementVNode("div", _hoisted_13, [
                                        (!notification.isRead)
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_14))
                                          : _createCommentVNode("", true),
                                        _createElementVNode("button", {
                                          class: "opacity-0 group-hover:opacity-100 transition-opacity p-1 rounded hover:bg-destructive/10",
                                          onClick: (e) => handleDelete(e, notification.id)
                                        }, [
                                          _createVNode(_unref(X), { class: "h-3 w-3 text-muted-foreground hover:text-destructive" })
                                        ], 8, _hoisted_15)
                                      ])
                                    ]),
                                    _createElementVNode("p", _hoisted_16, _toDisplayString(notification.message), 1),
                                    (isApprovalNotification(notification))
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                                          _createVNode(_unref(Badge), {
                                            variant: "secondary",
                                            class: "text-[10px]"
                                          }, {
                                            default: _withCtx(() => [...(_cache[11] || (_cache[11] = [
                                              _createTextVNode("Aprobación requerida", -1)
                                            ]))]),
                                            _: 1
                                          }),
                                          _createElementVNode("div", _hoisted_18, [
                                            _createVNode(_unref(Button), {
                                              size: "sm",
                                              class: "h-7 bg-emerald-600 hover:bg-emerald-700 text-white",
                                              disabled: submittingId.value === notification.id,
                                              onClick: (e) => handleApprove(e, notification)
                                            }, {
                                              default: _withCtx(() => [...(_cache[12] || (_cache[12] = [
                                                _createTextVNode(" Aprobar ", -1)
                                              ]))]),
                                              _: 1
                                            }, 8, ["disabled", "onClick"]),
                                            _createVNode(_unref(Button), {
                                              size: "sm",
                                              variant: "outline",
                                              class: "h-7 border-destructive/50 text-destructive hover:bg-destructive/10",
                                              disabled: submittingId.value === notification.id,
                                              onClick: (e) => openRejectDialog(e, notification)
                                            }, {
                                              default: _withCtx(() => [...(_cache[13] || (_cache[13] = [
                                                _createTextVNode(" Rechazar ", -1)
                                              ]))]),
                                              _: 1
                                            }, 8, ["disabled", "onClick"])
                                          ])
                                        ]))
                                      : _createCommentVNode("", true),
                                    _createElementVNode("p", _hoisted_19, _toDisplayString(formatDate(notification.createdAt)), 1)
                                  ])
                                ])
                              ], 10, _hoisted_8))
                            }), 128))
                          ]))
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_unref(TabsContent), {
                value: "unread",
                class: "flex-1 mt-0 min-h-0"
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(ScrollArea), { class: "h-full" }, {
                    default: _withCtx(() => [
                      (unreadNotifications.value.length === 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                            _createVNode(_unref(CheckCheck), { class: "h-12 w-12 mx-auto mb-3 opacity-50" }),
                            _cache[14] || (_cache[14] = _createElementVNode("p", null, "Todo al dia", -1))
                          ]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_21, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(unreadNotifications.value, (notification) => {
                              return (_openBlock(), _createElementBlock("div", {
                                key: notification.id,
                                class: "p-4 hover:bg-accent/50 cursor-pointer transition-colors bg-accent/30 group",
                                onClick: ($event: any) => (handleNotificationClick(notification))
                              }, [
                                _createElementVNode("div", _hoisted_23, [
                                  _createElementVNode("div", _hoisted_24, [
                                    _createElementVNode("div", _hoisted_25, [
                                      (_openBlock(), _createBlock(_resolveDynamicComponent(getNotificationIcon(notification.type)), { class: "h-4 w-4 text-primary" }))
                                    ])
                                  ]),
                                  _createElementVNode("div", _hoisted_26, [
                                    _createElementVNode("div", _hoisted_27, [
                                      _createElementVNode("p", _hoisted_28, _toDisplayString(notification.title), 1),
                                      _createElementVNode("div", _hoisted_29, [
                                        _cache[15] || (_cache[15] = _createElementVNode("div", { class: "h-2 w-2 rounded-full bg-primary" }, null, -1)),
                                        _createElementVNode("button", {
                                          class: "opacity-0 group-hover:opacity-100 transition-opacity p-1 rounded hover:bg-destructive/10",
                                          onClick: (e) => handleDelete(e, notification.id)
                                        }, [
                                          _createVNode(_unref(X), { class: "h-3 w-3 text-muted-foreground hover:text-destructive" })
                                        ], 8, _hoisted_30)
                                      ])
                                    ]),
                                    _createElementVNode("p", _hoisted_31, _toDisplayString(notification.message), 1),
                                    (isApprovalNotification(notification))
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                                          _createVNode(_unref(Badge), {
                                            variant: "secondary",
                                            class: "text-[10px]"
                                          }, {
                                            default: _withCtx(() => [...(_cache[16] || (_cache[16] = [
                                              _createTextVNode("Aprobación requerida", -1)
                                            ]))]),
                                            _: 1
                                          }),
                                          _createElementVNode("div", _hoisted_33, [
                                            _createVNode(_unref(Button), {
                                              size: "sm",
                                              class: "h-7 bg-emerald-600 hover:bg-emerald-700 text-white",
                                              disabled: submittingId.value === notification.id,
                                              onClick: (e) => handleApprove(e, notification)
                                            }, {
                                              default: _withCtx(() => [...(_cache[17] || (_cache[17] = [
                                                _createTextVNode(" Aprobar ", -1)
                                              ]))]),
                                              _: 1
                                            }, 8, ["disabled", "onClick"]),
                                            _createVNode(_unref(Button), {
                                              size: "sm",
                                              variant: "outline",
                                              class: "h-7 border-destructive/50 text-destructive hover:bg-destructive/10",
                                              disabled: submittingId.value === notification.id,
                                              onClick: (e) => openRejectDialog(e, notification)
                                            }, {
                                              default: _withCtx(() => [...(_cache[18] || (_cache[18] = [
                                                _createTextVNode(" Rechazar ", -1)
                                              ]))]),
                                              _: 1
                                            }, 8, ["disabled", "onClick"])
                                          ])
                                        ]))
                                      : _createCommentVNode("", true),
                                    _createElementVNode("p", _hoisted_34, _toDisplayString(formatDate(notification.createdAt)), 1)
                                  ])
                                ])
                              ], 8, _hoisted_22))
                            }), 128))
                          ]))
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_unref(TabsContent), {
                value: "grouped",
                class: "flex-1 mt-0 min-h-0"
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(ScrollArea), { class: "h-full" }, {
                    default: _withCtx(() => [
                      (groupedNotifications.value.length === 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                            _createVNode(_unref(Bell), { class: "h-12 w-12 mx-auto mb-3 opacity-50" }),
                            _cache[19] || (_cache[19] = _createElementVNode("p", null, "No hay notificaciones", -1))
                          ]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_36, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(groupedNotifications.value, (group) => {
                              return (_openBlock(), _createBlock(_unref(Collapsible), {
                                key: group.group,
                                "default-open": true,
                                class: "border-b last:border-b-0"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_unref(CollapsibleTrigger), {
                                    class: "flex w-full items-center justify-between px-4 py-2.5 hover:bg-accent/50 transition-colors",
                                    onClick: ($event: any) => (toggleGroup(group.group))
                                  }, {
                                    default: _withCtx(() => [
                                      _createElementVNode("div", _hoisted_37, [
                                        (_openBlock(), _createBlock(_resolveDynamicComponent(getGroupIcon(group.group)), { class: "h-4 w-4 text-muted-foreground" })),
                                        _createElementVNode("span", _hoisted_38, _toDisplayString(group.label), 1),
                                        (group.unreadCount > 0)
                                          ? (_openBlock(), _createElementBlock("span", _hoisted_39, _toDisplayString(group.unreadCount), 1))
                                          : _createCommentVNode("", true),
                                        _createElementVNode("span", _hoisted_40, "(" + _toDisplayString(group.notifications.length) + ")", 1)
                                      ]),
                                      _createVNode(_unref(ChevronDown), {
                                        class: _normalizeClass(["h-4 w-4 text-muted-foreground transition-transform", { '-rotate-90': collapsedGroups.value.has(group.group) }])
                                      }, null, 8, ["class"])
                                    ]),
                                    _: 2
                                  }, 1032, ["onClick"]),
                                  _createVNode(_unref(CollapsibleContent), null, {
                                    default: _withCtx(() => [
                                      _createElementVNode("div", _hoisted_41, [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(group.notifications, (notification) => {
                                          return (_openBlock(), _createElementBlock("div", {
                                            key: notification.id,
                                            class: _normalizeClass(["px-4 py-3 hover:bg-accent/50 cursor-pointer transition-colors group", { 'bg-accent/30': !notification.isRead }]),
                                            onClick: ($event: any) => (handleNotificationClick(notification))
                                          }, [
                                            _createElementVNode("div", _hoisted_43, [
                                              _createElementVNode("div", _hoisted_44, [
                                                _createElementVNode("div", _hoisted_45, [
                                                  _createElementVNode("p", {
                                                    class: _normalizeClass(["text-sm", notification.isRead ? 'text-muted-foreground' : 'font-medium'])
                                                  }, _toDisplayString(notification.title), 3),
                                                  _createElementVNode("div", _hoisted_46, [
                                                    (!notification.isRead)
                                                      ? (_openBlock(), _createElementBlock("div", _hoisted_47))
                                                      : _createCommentVNode("", true),
                                                    _createElementVNode("button", {
                                                      class: "opacity-0 group-hover:opacity-100 transition-opacity p-1 rounded hover:bg-destructive/10",
                                                      onClick: (e) => handleDelete(e, notification.id)
                                                    }, [
                                                      _createVNode(_unref(X), { class: "h-3 w-3 text-muted-foreground hover:text-destructive" })
                                                    ], 8, _hoisted_48)
                                                  ])
                                                ]),
                                                _createElementVNode("p", _hoisted_49, _toDisplayString(notification.message), 1),
                                                (isApprovalNotification(notification))
                                                  ? (_openBlock(), _createElementBlock("div", _hoisted_50, [
                                                      _createVNode(_unref(Badge), {
                                                        variant: "secondary",
                                                        class: "text-[10px]"
                                                      }, {
                                                        default: _withCtx(() => [...(_cache[20] || (_cache[20] = [
                                                          _createTextVNode("Aprobación requerida", -1)
                                                        ]))]),
                                                        _: 1
                                                      }),
                                                      _createElementVNode("div", _hoisted_51, [
                                                        _createVNode(_unref(Button), {
                                                          size: "sm",
                                                          class: "h-7 bg-emerald-600 hover:bg-emerald-700 text-white",
                                                          disabled: submittingId.value === notification.id,
                                                          onClick: (e) => handleApprove(e, notification)
                                                        }, {
                                                          default: _withCtx(() => [...(_cache[21] || (_cache[21] = [
                                                            _createTextVNode(" Aprobar ", -1)
                                                          ]))]),
                                                          _: 1
                                                        }, 8, ["disabled", "onClick"]),
                                                        _createVNode(_unref(Button), {
                                                          size: "sm",
                                                          variant: "outline",
                                                          class: "h-7 border-destructive/50 text-destructive hover:bg-destructive/10",
                                                          disabled: submittingId.value === notification.id,
                                                          onClick: (e) => openRejectDialog(e, notification)
                                                        }, {
                                                          default: _withCtx(() => [...(_cache[22] || (_cache[22] = [
                                                            _createTextVNode(" Rechazar ", -1)
                                                          ]))]),
                                                          _: 1
                                                        }, 8, ["disabled", "onClick"])
                                                      ])
                                                    ]))
                                                  : _createCommentVNode("", true),
                                                _createElementVNode("p", _hoisted_52, _toDisplayString(formatDate(notification.createdAt)), 1)
                                              ])
                                            ])
                                          ], 10, _hoisted_42))
                                        }), 128))
                                      ])
                                    ]),
                                    _: 2
                                  }, 1024)
                                ]),
                                _: 2
                              }, 1024))
                            }), 128))
                          ]))
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["modelValue"]),
          _createVNode(_unref(Separator)),
          _createElementVNode("div", _hoisted_53, [
            _createVNode(_unref(Button), {
              variant: "outline",
              class: "w-full",
              onClick: goToNotifications
            }, {
              default: _withCtx(() => [...(_cache[23] || (_cache[23] = [
                _createTextVNode(" Ver todas las notificaciones ", -1)
              ]))]),
              _: 1
            })
          ])
        ]),
        _: 1
      }),
      _createVNode(_unref(Dialog), {
        open: rejectDialogOpen.value,
        "onUpdate:open": _cache[3] || (_cache[3] = ($event: any) => ((rejectDialogOpen).value = $event))
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(DialogContent), { class: "sm:max-w-md" }, {
            default: _withCtx(() => [
              _createVNode(_unref(DialogHeader), null, {
                default: _withCtx(() => [
                  _createVNode(_unref(DialogTitle), null, {
                    default: _withCtx(() => [...(_cache[24] || (_cache[24] = [
                      _createTextVNode("Rechazar pipeline", -1)
                    ]))]),
                    _: 1
                  }),
                  _createVNode(_unref(DialogDescription), null, {
                    default: _withCtx(() => [...(_cache[25] || (_cache[25] = [
                      _createTextVNode(" Indica el motivo del rechazo. Es obligatorio. ", -1)
                    ]))]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_unref(Textarea), {
                modelValue: rejectReason.value,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((rejectReason).value = $event)),
                placeholder: "Motivo del rechazo…",
                rows: "3",
                disabled: submittingId.value !== null
              }, null, 8, ["modelValue", "disabled"]),
              _createVNode(_unref(DialogFooter), null, {
                default: _withCtx(() => [
                  _createVNode(_unref(Button), {
                    variant: "outline",
                    disabled: submittingId.value !== null,
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (rejectDialogOpen.value = false))
                  }, {
                    default: _withCtx(() => [...(_cache[26] || (_cache[26] = [
                      _createTextVNode(" Cancelar ", -1)
                    ]))]),
                    _: 1
                  }, 8, ["disabled"]),
                  _createVNode(_unref(Button), {
                    variant: "destructive",
                    disabled: !rejectReason.value.trim() || submittingId.value !== null,
                    onClick: confirmReject
                  }, {
                    default: _withCtx(() => [...(_cache[27] || (_cache[27] = [
                      _createTextVNode(" Rechazar ", -1)
                    ]))]),
                    _: 1
                  }, 8, ["disabled"])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["open"])
    ]),
    _: 1
  }, 8, ["open"]))
}
}

})